import React from 'react';

const OnetAttribution = ({ 
  className = '',
  showBorder = true,
  size = 'default' // 'sm' | 'default' | 'lg'
}) => {
  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return {
          container: 'mt-4 pt-3',
          image: { width: '100px', height: '46px' },
          text: 'text-xs'
        };
      case 'lg':
        return {
          container: 'mt-8 pt-6',
          image: { width: '160px', height: '74px' },
          text: 'text-sm'
        };
      default:
        return {
          container: 'mt-6 pt-4',
          image: { width: '130px', height: '60px' },
          text: 'text-xs'
        };
    }
  };

  const sizeClasses = getSizeClasses();

  return (
    <div className={`${sizeClasses.container} ${showBorder ? 'border-t border-border' : ''} ${className}`}>
      <div className="text-center">
        <p style={{ textAlign: 'center', marginBottom: '8px' }}>
          <a 
            href="https://services.onetcenter.org/" 
            title="This site incorporates information from O*NET Web Services. Click to learn more."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block"
          >
            <img 
              src="https://www.onetcenter.org/image/link/onet-in-it.svg" 
              style={sizeClasses.image} 
              alt="O*NET in-it"
              className="mx-auto"
            />
          </a>
        </p>
        <p className={`${sizeClasses.text} text-muted-foreground`}>
          This site incorporates information from{' '}
          <a 
            href="https://services.onetcenter.org/" 
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:underline"
          >
            O*NET Web Services
          </a>{' '}
          by the U.S. Department of Labor, Employment and Training Administration (USDOL/ETA). 
          O*NET&reg; is a trademark of USDOL/ETA.
        </p>
      </div>
    </div>
  );
};

export default OnetAttribution;
